/**
 * A simple in-memory logger with an observer pattern for real-time log updates.
 * This allows different parts of the application to log events and a central
 * place (like a debug panel) to subscribe and display them.
 */
const logs = [];
const MAX_LOGS = 100; // Store a maximum of 100 log entries
const subscribers = new Set();

const log = (type, message, status, details = {}) => {
  const logEntry = {
    timestamp: new Date(),
    type,     // e.g., 'API', 'DB', 'BACKUP', 'EMAIL', 'SYSTEM'
    message,
    status,   // e.g., 'SUCCESS', 'ERROR', 'INFO'
    details,
  };

  logs.unshift(logEntry); // Add to the beginning for chronological order (newest first)

  if (logs.length > MAX_LOGS) {
    logs.pop(); // Keep the log array size manageable
  }

  // Notify subscribers of the new log entry
  subscribers.forEach(callback => callback(logEntry));
};

export const logger = {
  info: (type, message, details = {}) => log(type, message, 'INFO', details),
  success: (type, message, details = {}) => log(type, message, 'SUCCESS', details),
  error: (type, message, details = {}) => log(type, message, 'ERROR', details),
  getLogs: () => [...logs], // Return a copy to prevent mutation
  subscribe: (callback) => {
    subscribers.add(callback);
    // Return an unsubscribe function for cleanup
    return () => subscribers.delete(callback);
  },
  clear: () => {
    logs.length = 0;
    // Notify subscribers that logs have been cleared
    subscribers.forEach(callback => callback(null)); // Special signal to clear
  }
};